import AdvisersApi from '../../../../core/api/AdvisersApi'
import AdviserStatusCodesApi from '../../../../core/api/AdviserStatusCodesApi'
const api = new AdvisersApi()
const statusCodeApi = new AdviserStatusCodesApi()

export const events = {
  load: {
    fetching: 'WHITELISTING_FETCHING_ADVISERS',
    fetched: 'WHITELISTING_FETCHED_ADVISERS',
    fetchedAdviserStatusCodes: 'WHITELISTING_FETCHED_ADVISER_STATUS_CODES'
  },
  set: {
    setAdviserStatusCode: 'WHITELISTING_SET_ADVISER_STATUS_CODE',
    searchTerm: 'WHITELISTING_SET_SEARCH_TERM'
  },
  submitting: {
    adviser: 'WHITELISTING_SUBMITTING_ADVISER'
  },
  submitted: {
    adviser: 'WHITELISTING_SUBMITTED_ADVISER'
  }
}

export const actions = {
  load: {
    fetchAdvisers: () => {
      const adviserRequest = api.getAllAdvisers()

      return (dispatch) => {
        dispatch({type: events.load.fetching})
        adviserRequest.then((res) => {
          dispatch(api.handleResponse(events.load.fetched, res))
        })
      }
    },
    fetchAdviserStatusCodes: () => {
      const statusCodeReq = statusCodeApi.getAdviserStatusCodes()

      return (dispatch) => {
        statusCodeReq.then((res) => {
          dispatch(statusCodeApi.handleResponse(events.load.fetchedAdviserStatusCodes, res))
        })
      }
    },
    fetchAdviserProfiles: (searchTerm) => {
      const fetchAdviserProfilesReq = api.getAdviserProfiles(searchTerm)

      return (dispatch) => {
        dispatch({type: events.load.fetching})
        fetchAdviserProfilesReq.then((res) => {
          dispatch(api.handleResponse(events.load.fetched, res))
        })
      }
    }
  },
  set: {
    adviserStatusCode: (statusCode, index) => ({
      type: events.set.setAdviserStatusCode,
      statusCode,
      index
    }),
    searchTerm: (searchTerm) => ({
      type: events.set.searchTerm,
      searchTerm
    })
  },
  submit: {
    submitAdviserStatusCode: (adviser) => {
      const adviserRequest = api.setAdviserStatusCode(adviser)

      return (dispatch) => {
        dispatch({type: events.submitting.adviser})
        adviserRequest.then((res) => {
          dispatch(api.handleResponse(events.submitted.adviser, res))
        })
      }
    }
  }
}
